/**
 * @generated SignedSource<<b5839aca839da6ffa66516545c395b77>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "billToAccountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endts"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "invoiceNumber"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderDirection"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startts"
},
v7 = [
  {
    "kind": "Variable",
    "name": "billtoaccountid",
    "variableName": "billToAccountId"
  },
  {
    "kind": "Variable",
    "name": "endts",
    "variableName": "endts"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "invoicenumber",
    "variableName": "invoiceNumber"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "orderdirection",
    "variableName": "orderDirection"
  },
  {
    "kind": "Variable",
    "name": "startts",
    "variableName": "startts"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceDate",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceNumber",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceDescription",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ResellerInvoiceSummaryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "InvoiceTsConnection",
        "kind": "LinkedField",
        "name": "getinvoicesbydate",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "ResellerInvoiceSummaryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "InvoiceTsConnection",
        "kind": "LinkedField",
        "name": "getinvoicesbydate",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceT",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7a42541a2366f2f3f8ea0b1e673c8e7a",
    "id": null,
    "metadata": {},
    "name": "ResellerInvoiceSummaryQuery",
    "operationKind": "query",
    "text": "query ResellerInvoiceSummaryQuery(\n  $billToAccountId: UUID!\n  $invoiceNumber: String!\n  $startts: Datetime\n  $endts: Datetime\n  $orderDirection: Int\n  $first: Int\n  $offset: Int\n) {\n  getinvoicesbydate(billtoaccountid: $billToAccountId, invoicenumber: $invoiceNumber, startts: $startts, endts: $endts, orderdirection: $orderDirection, first: $first, offset: $offset) {\n    totalCount\n    nodes {\n      invoiceId\n      invoiceDate\n      invoiceNumber\n      invoiceDescription\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "7f97ce89c2493163f21e180e47071389";

module.exports = node;
